import React from 'react';

const EthicRedirect = () => {
  window.location.href = 'https://manserv.fluigidentity.com/cloudpass/?forward=%2FSPInitPost%2FreceiveSSORequest%2F2cbp2mgimnsg0v8d1434473628905%2Fo7fzggeaqhc1fut31471876606303';
};

export default EthicRedirect;
